// extracted by mini-css-extract-plugin
module.exports =  {"sectionToggle":"sectionToggle__YkPi2"};